// extracted by mini-css-extract-plugin
module.exports = {"title":"SubjectBox_title__fWrwB","listElement":"SubjectBox_listElement__k_6Ha"};